import { mapState } from 'vuex'
import debounce from 'lodash-es/debounce'
import gtmFSF from 'services/AirBaltic/GTM/FSF'
import SearchSessionStorageMixin from './SearchSessionStorage'

const DestinMixin = {
  computed: {
    ...mapState('searchForm', ['destin']),
    ...mapState('device', ['deviceType'])
  },

  mixins: [SearchSessionStorageMixin],

  methods: {
    onDestinFocused(labelGtm = null) {
      const isOriginSet = this.origin.value.code === undefined
      if (isOriginSet) {
        this.$refs.origin.focus()
      } else {
        const isDestinOpen = this.destin.typeahead.open
        if (!isDestinOpen) {
          this.showDestinTypeahead(false, labelGtm)
        }
      }
    },
    destinCloseAll() {
      this.$store.dispatch('eHorizonSearchForm/destin/closeTypeahead')
    },
    onDestinCountrySelected(country) {
      this.$store.dispatch('eHorizonSearchForm/destin/updateCountry', country)
    },
    showDestinTypeahead(origin = false, seenLabelsGtmPosition = null) {
      this.$store.commit('eHorizonSearchForm/destin/typeahead/open')

      if (!this.$refs.destin.hasFocus() && this.deviceType !== 'mobile') {
        this.$refs.destin.focus()
      }

      if (seenLabelsGtmPosition) {
        gtmFSF.labelsSeen(seenLabelsGtmPosition)
      }

      if (!origin) {
        gtmFSF.destinTypeaheadNoResultsShow(this.origin.value.code)
      }
    },
    onDestinFilter: debounce(function (value) {
      this.$store.dispatch('eHorizonSearchForm/destin/doFilter', value)
      this.$store.commit('eHorizonSearchForm/destin/setSelectedLabel', 'label_all')
    }, 0),
    onDestinOpenUpdate(openBl) {
      if (!openBl && this.destin.typeahead.open) {
        this.destinCloseAll()
      }
    },
    onDestinLabelUpdate(label) {
      this.$store.commit('eHorizonSearchForm/destin/setSelectedLabel', label)
    },
    onDestinSelected(destinValue, updateSession = false, resetSession = false) {
      if (typeof destinValue.bxClickUrl !== 'undefined') {
        gtmFSF.onDestinSelected(this.origin.value.code, destinValue.code)
      }

      this.$store.dispatch('eHorizonSearchForm/destin/onValueSelect', destinValue)

      if (updateSession) {
        this.$_searchSessionStorageMixin_updateDestinSessionStorage(resetSession)
      }
    }
  }
}

export default DestinMixin
